import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { NinChangeboardingTourCard } from '@atlassian/jira-issue-navigator-changeboarding/src/controllers/enable-nin-changeboarding/index.tsx';
import { toSearchModeWithBasicModeFallback } from '@atlassian/jira-jql-builder/src/common/utils.tsx';
import type { spotlight_issueNavigator_IssueNavigatorSpotlight$key as UserPreferencesFragmentKey } from '@atlassian/jira-relay/src/__generated__/spotlight_issueNavigator_IssueNavigatorSpotlight.graphql';
import { convertToView } from '../../common/utils/index.tsx';
import { useSelectedViewState } from '../../controllers/selected-view-state/index.tsx';

type Props = {
	hasIssueResults: boolean;
	userPreferences: UserPreferencesFragmentKey | null;
	isAiEnabled: boolean;
};

const IssueNavigatorSpotlight = ({ hasIssueResults, userPreferences, isAiEnabled }: Props) => {
	const [{ view }] = useSelectedViewState();

	const searchModeResponse = useFragment<UserPreferencesFragmentKey>(
		graphql`
			fragment spotlight_issueNavigator_IssueNavigatorSpotlight on JiraUserPreferences {
				jqlBuilderSearchMode
			}
		`,
		userPreferences,
	);

	const selectedSearchMode = toSearchModeWithBasicModeFallback(
		searchModeResponse?.jqlBuilderSearchMode,
	);

	return (
		<NinChangeboardingTourCard
			mode={selectedSearchMode}
			view={convertToView(view)}
			hasIssueResults={hasIssueResults}
			isAiEnabled={isAiEnabled}
		/>
	);
};

export default IssueNavigatorSpotlight;
